import React, { Fragment, useEffect, useState } from "react";
import {
  addGiftCode,
  deleteGiftCode,
  getServiceGiftCodes,
} from "../apps_manage/api";
import MyLoader from "../../util/MyLoader";
import { useNavigate, useParams } from "react-router-dom";
import { Constant } from "../../util/Constant";
import { Delete, Plus, Trash2 } from "lucide-react";
import { SolidButton } from "../../global/SolidButton";
import { MyModal } from "../../global/MyModal";
import Pagination from "../../util/Pagination";
import { format } from "date-fns";
import toast from "react-hot-toast";

export default function GiftCards() {
  const [giftCodes, setGiftCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  // const [isOpenCal, setIsOpenCal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  //data
  const [service, setService] = useState("amazon_giftcode");
  const [amount, setAmount] = useState(0);
  const [expireAt, setExpireAt] = useState(() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() + 1);
    return d;
  });
  const [code, setCode] = useState("");
  const [errors, setErrors] = useState({});

  // pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const { id } = useParams();

  const fetchGiftCard = async () => {
    try {
      // Simulate API call delay
      const res = await getServiceGiftCodes(id, {
        page: page,
        limit: limit,
        status:
          activeTab === 1 ? "all" : activeTab === 2 ? "available" : "used",
      });
      if (res?.status === 200) {
        const data = res?.data;
        setGiftCodes(data.giftcards);
        setTotal(data.total);
        setService(data.service);
        setAmount(data.amount);
      }
    } catch (error) {
      console.error("Error fetching gift card data:", error);
    } finally {
      setLoading(false);
    }
  };
  const type = [
    { id: 1, label: "All", value: "all" },
    { id: 2, label: "Available", value: "available" },
    { id: 3, label: "Used", value: "used" },
  ];

  const navigate = useNavigate();
  const handleTabClick = (tabId) => {
    const selectedTab = type.find((item) => item.id === tabId);

    if (!selectedTab) return;

    navigate(`/payout/giftcodes/${id}?status=${selectedTab.value}`);
    setActiveTab(tabId);
  };
  useEffect(() => {
    fetchGiftCard();
  }, [activeTab, page, limit]);

  const validateForm = () => {
    const errs = {};
    if (code === "") {
      errs.code = "gift code is required";
    }

    if (service === "") {
      errs.service = "service is required";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      const payload = {
        code: code,
        amount: amount,
        service: service,
        gateway: "adwave",
        expires_at: expireAt,
      };

      const res = await addGiftCode(payload);
      if (res?.status === 200) {
        // success toast
        toast.success("Gift code added successfully");
        setIsModelOpen(false);
        fetchGiftCard();
      }
    } catch (error) {
      console.error("Error adding gift code:", error);
      // error toast
      toast.error("Failed to add gift code");
    }
  };

  const handleDelete = async () => {
    try {
      const res = await deleteGiftCode(deleteId);
      if (res.status === 200) {
        toast.success("Gift code deleted successfully");
        // refresh list
        fetchGiftCard();
      }
    } catch (err) {
      console.error("Failed to delete gift code", err);
      toast.error(err.response?.data?.error || "Failed to delete gift code");
    }
    setDeleteId(null);
  };

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-6 relative" id="devices-main">
        <div className="w-full flex items-end justify-end">
          <SolidButton
            className="py-1 px-2   "
            onClick={() => setIsModelOpen(true)}
          >
            <Plus size={14} />
            <span>Add Gift Code</span>
          </SolidButton>
        </div>

        <div
          className="bg-white/80 dark:bg-slate-900/80
       backdrop-blur-xl rounded-2xl  
       border border-state-200/50 dark:border-slate-700/50 
        w-full 
       overflow-x-auto
      "
        >
          <div className="flex items-center justify-center p-4 ">
            <div className="flex flex-col space-y-1 ">
              <h1 className="text-sm text-slate-900 dark:text-slate-200 font-bold">
                Inventory Overview
              </h1>
              <span className="text-xs text-slate-500 :dark:text-slate-200 font-normal">
                All Codes here by same type and amount
              </span>
            </div>
            {/* tabs */}
            <div
              className="flex ml-auto py-2 p-2 bg-slate-300/25 dark:bg-gray-700/30 backdrop-blur-xl rounded-lg   
              "
            >
              {type.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={` text-xs font-medium border 
                 mr-2
           p-1 rounded-sm transition-all duration-200 transform
           text-slate-800 dark:text-slate-300  ${
             tab.id === activeTab
               ? "bg-white dark:bg-slate-100/2 border dark:via-slate-800 dark:to-slate-900 border-slate-300"
               : "border-transparent cursor-pointer"
           }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
          <table className="min-w-full ">
            <thead className="w-full">
              <tr className=" bg-slate-100 dark:bg-slate-800/60 border-t   border-slate-300 dark:border-slate-700">
                <th className="text-start   text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ps-4">
                  Service
                </th>
                <th className="text-start   text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ps-4">
                  Gift Code
                </th>
                <th className="text-center  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Amount
                </th>
                <th className="text-center  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Gateway
                </th>
                <th className="text-center  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Status
                </th>
                <th className="text-start  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ps-10 ">
                  Expiry
                </th>
                <th className="text-start  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ">
                  Created At
                </th>
              </tr>
            </thead>
            <tbody>
              {giftCodes.map((item, index) => (
                <tr
                  key={index}
                  className="w-full hover:bg-slate-100 dark:hover:bg-gray-800/20"
                >
                  <td className="text-start   text-xs font-normal  text-slate-900 dark:text-slate-200 py-2 ps-4">
                    {item.service}
                  </td>
                  <td className="text-start   text-[10px] font-thin font-mono  text-slate-900 dark:text-slate-200 py-2 ps-4">
                    {item.code}
                  </td>

                  <td className="text-start py-3  flex justify-center ">
                    <span className="text-sm font-normal  text-green-600 dark:text-gray-100 rounded-full px-2 py-1 bg-green-600/10 dark:bg-green-500/15">
                      {Constant.UniCode.rupees + item.amount}
                    </span>
                  </td>

                  <td className="text-center  text-sm font-normal text-slate-900 dark:text-slate-300 py-3  ">
                    {item.gateway}
                  </td>

                  <td className="text-start py-3  flex justify-center space-x-2 px-2">
                    <span
                      className={`text-[10px] font-semibold flex justify-center items-center rounded-xl px-2 py-0.5  ${item.is_used ? "text-red-600 bg-red-600/20" : "text-green-600 bg-green-500/20"} `}
                    >
                      {item.is_used ? "Used" : "Available"}
                    </span>
                    {item.is_used && (
                      <span className="text-sm font-normal flex justify-center items-center  text-red-600 dark:text-gray-100 rounded-full px-2  bg-red-600/10 dark:bg-red-500/15">
                        Used on {new Date(item.used_at).toLocaleDateString()}
                      </span>
                    )}
                  </td>

                  <td className="text-start   text-xs font-normal  text-slate-900 dark:text-slate-300 py-2 ps-10">
                    {item.expires_at
                      ? (() => {
                          const now = new Date();
                          const expiry = new Date(item.expires_at);
                          const diff = expiry - now;

                          if (diff <= 0) return "Expired";

                          const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                          //   const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
                          //   const minutes = Math.floor((diff / (1000 * 60)) % 60);

                          //  return `${days}day - ${hours}h ${minutes}m left`;
                          return `${days} days left`;
                        })()
                      : "No Expiry"}
                  </td>
                  <td className="text-start   text-xs font-normal  text-slate-900 dark:text-slate-400 py-2 pe-2">
                    {new Date(item.created_at).toLocaleDateString()}
                  </td>
                  <td className="text-start   text-xs font-normal  text-slate-900 dark:text-slate-300 py-2 ps-4">
                    <Trash2
                      onClick={() => setDeleteId(item.id)}
                      className="text-red-500 cursor-pointer"
                      size={16}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="w-full b-0 absolute">
          <Pagination
            page={page}
            limit={limit}
            total={total}
            fixed={false}
            onPageChange={setPage}
            onLimitChange={(l) => {
              setLimit(l);
              setPage(1); // reset to first page
            }}
            constrainTo="#devices-main"
          />
        </div>
      </div>
      <MyModal
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        title="Add New Gift Card"
        width="530px"
      >
        <div className="flex flex-col space-y-4 ">
          {/* Service */}
          <div className="flex flex-col col-span-1 mt-4">
            <label className=" text-xs  font-medium text-black-600 dark:text-slate-500  ">
              Service
            </label>
            <select
              name="service"
              value={service}
              // defaultValue={service}

              onChange={(e) => {
                setService(e.target.value);
              }}
              className={`w-full px-2  py-2 
              bg-slate-100 dark:bg-slate-800 
              border  
              rounded-md mt-2
              text-slate-800 dark:text-white text-xs
              placeholder-slate-500 focus:outline-none focus:ring-2
              focus:ring-blue-500 focus:border-transparent transition-all ${"border-slate-200 dark:border-slate-700"}`}
            >
              <option value={service}>{service}</option>
            </select>
          </div>
          {/* Amount */}
          <div className="mt-2">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Gift Anount*
            </label>

            {/* Input */}
            <input
              type="number"
              placeholder="Enter gift Amount"
              value={amount}
              readOnly
              onChange={(e) => setAmount(e.target.value)}
              className="w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
            />
          </div>
          {/* Code */}
          <div className="mt-2">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Gift Code*
            </label>

            {/* Input */}
            <input
              type="text"
              placeholder="e.g. ABCD-1234-EFGH"
              value={code}
              onChange={(e) => {
                setCode(e.target.value);
                if (errors.code)
                  setErrors((prev) => ({ ...prev, code: undefined }));
              }}
              className={`w-full text-xs py-2.5 px-3  bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all   ${
                errors.code
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />
            {errors.code && (
              <div className="text-xs text-red-500 mt-1">{errors.code}</div>
            )}
          </div>
          {/* Expire */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-2">
              Expire At*
            </label>

            <div className="relative cursor-pointer">
              {/* Input */}
              <input
                type="date"
                placeholder="e.g. 2024-12-31"
                value={expireAt ? format(expireAt, "yyyy-MM-dd") : ""}
                min={format(new Date(), "yyyy-MM-dd")} // ✅ restrict past dates
                onChange={(e) => {
                  setExpireAt(new Date(e.target.value)); // ✅ convert to Date
                }}
                // readOnly
                className="w-full text-xs py-2.5 pl-9 pr-3 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all border-slate-200 dark:border-slate-700"
              />
            </div>
          </div>
          {/* action */}
          <div className="flex items-center justify-end space-x-4 mt-4 ml-auto">
            <button
              className="px-4 py-2 rounded-lg
                       bg-slate-400/20 dark:bg-slate-800 
                       text-slate-800 dark:text-slate-300 text-sm font-semibold
                       hover:bg-slate-400/30 dark:hover:bg-slate-700 
                       transition-all duration-300"
              onClick={() => {
                setIsModelOpen(false);
                setErrors({});
              }}
            >
              Cancel
            </button>
            <SolidButton
              children={<span>Add New</span>}
              onClick={(e) => {
                handleSubmit(e);
              }}
            />
          </div>
        </div>
      </MyModal>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Gift Code?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this Gift Code?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}
